export default __webpack_public_path__ + "static/intersection-2-2876e2a7170ff37041b9b81cb4bb49f8.jpg";